

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"120","height":"120","viewBox":"0 0 120 120","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('path', {"d":"M36.663 84.383h51.768c.867 0 1.569.698 1.569 1.558v3.5c0 .861-.702 1.559-1.569 1.559H32.299A2.29 2.29 0 0130 88.717V30.558c0-.86.702-1.558 1.569-1.558h3.525c.867 0 1.57.698 1.57 1.558v30.273l8.126-8.07a3.348 3.348 0 014.712 0L62.72 65.886l14.238-14.14H72.06a1.564 1.564 0 01-1.57-1.557v-3.501c0-.86.703-1.558 1.57-1.558h13.974a2.29 2.29 0 012.3 2.283V61.29c0 .86-.703 1.558-1.57 1.558h-3.525a1.564 1.564 0 01-1.57-1.558v-4.866L65.076 72.904a3.335 3.335 0 01-2.356.97c-.877 0-1.723-.341-2.356-.97L47.146 59.779l-10.483 10.41v14.194z","fill":"#FFF","fill-rule":"evenodd"}, [])]);
};

        